// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e893464c","455":"6daf519c","977":"36d96913"}[chunkId] + ".chunk.js";
};